(() => {
  const root = document.querySelector(".scroll-progress");
  if (!root) return;

  const bar = root.querySelector(".scroll-progress__bar");
  if (!bar) return;

  let ticking = false;

  const update = () => {
    const doc = document.documentElement;
    const scrollTop = window.pageYOffset || doc.scrollTop || 0;

    const scrollHeight = doc.scrollHeight - doc.clientHeight;
    const progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;

    bar.style.width = `${Math.max(1, Math.min(100, progress))}%`;
    ticking = false;
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  update();
})();
